module.exports = __webpack_public_path__ + "img/document.3c4e62f2.svg";